import { ErrorHandler } from "@angular/core";

export class GlobalErrorHandler extends ErrorHandler {
    override handleError(error: any): void {
        // MARK: Need an actual strategy!
        console.error(`GEH -> Error: `, error);
        throw error;
    }
}
